'use strict';

module.exports = function safeRender(React, config) {
    config = config || {};
    config.errorHandler = config.errorHandler || function () {};

    if (React.hasOwnProperty('unsafeCreateClass')) {
        return;
    }

    React.unsafeCreateClass = React.createClass;

    React.createClass = function (spec) {
        var componentClass = {};

        function wrap(method, returnFn) {
            if (!spec.hasOwnProperty(method)) {
                return;
            }

            var unsafe = spec[method];

            spec[method] = function () {
                try {
                    return unsafe.apply(this, arguments);
                } catch (e) {
                    var report = {
                        displayName: componentClass.displayName,
                        method: method,
                        props: this.props,
                        error: e
                    };
                    if (arguments.length > 0) {
                        report.arguments = arguments;
                    }
                    config.errorHandler(report);
                    return typeof returnFn === 'function' ? returnFn.apply(this, arguments) : null;
                }
            };
        }

        wrap('render');
        wrap('componentWillMount');
        wrap('componentDidMount');
        wrap('componentWillReceiveProps');
        wrap('shouldComponentUpdate');
        wrap('componentWillUpdate');
        wrap('componentDidUpdate');
        wrap('componentWillUnmount');
        wrap('getInitialState');

        // store ref to class in closure so error reporting can be more specific
        componentClass = React.unsafeCreateClass.apply(React, arguments);

        return componentClass;
    };

    return React;
};

module.exports.errorHandler = function errorHandler(errorObj) {
    var env = require('./environments').get() || 'DEV';
    if (env == "DEV" || env == "LOCAL") {
        console.warn("Error in", errorObj.displayName, "within function", errorObj.method, "Props passed in: ", errorObj.props);
        console.error("Error message: ", errorObj.error);
    } else {
        window.location.href = '/error.html';
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/reactErrorHandlingWrapper.js
// module id = 863
// module chunks = 0